export interface ClientImage {
  url: string;
  date: Date;
  type?: string;
}

export enum MenuOption {
  Logo = 'Logo',
  Primary = 'Primary',
  Gallery = 'Gallery',
  Delete = 'Delete',
}
